import {
    getArchiveListRequest,
    getBasePoliceListRequest,
} from '../../../../services/network/sell/base';

class CommonBaseAndArchiveService {
    async getArchiveList(params) {
        return await getArchiveListRequest(params);
    }

    async getBasePoliceList(params) {
        return await getBasePoliceListRequest(params);
    }
}

export const BaseAndArchiveService = new CommonBaseAndArchiveService();
